import Link from 'next/link';
import React from 'react';
import { IButtonLinkProps } from './_props';

interface Props extends Pick<IButtonLinkProps, 'prefetch' | 'href' | 'useNextLink'> {
  children: React.ReactElement;
}

export default function LinkWrapper({ useNextLink, prefetch, href, children }: Props) {
  return useNextLink ? (
    // TODO: migrate to Next 13 taking out the legacyBehavior this should force modify others components
    <Link prefetch={prefetch} href={href} legacyBehavior>
      {children}
    </Link>
  ) : (
    React.cloneElement(children, { href })
  );
}
